import React from 'react';

interface CmsSkinnyTextData {
  body?: string;
  background_color?: string;
}

interface CmsSkinnyTextProps {
  data: CmsSkinnyTextData;
}

export const CmsSkinnyRichText: React.FC<CmsSkinnyTextProps> = ({ data }) => {
  if (!data.body) {
    return null;
  }

  return (
    <div
      className="flex justify-center items-center w-full"
      style={{ backgroundColor: data.background_color ?? 'transparent' }}
    >
      <div
        className="w-full [&>p]:m-0 prose"
        style={{
          maxWidth: '1114px',
          color: '#34363B',
          fontFeatureSettings: "'liga' off, 'clig' off",
        }}
        dangerouslySetInnerHTML={{ __html: data.body }}
      />
    </div>
  );
};

export default CmsSkinnyRichText;
